var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('perfect-scrollbar',[_c('div',{staticClass:"eventGrid"},_vm._l((_vm.events),function(event){return _c('EventCard',{key:event.id,staticClass:"fade-in",attrs:{"event":event}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }